<template>
  <page-list
    :list="list"
    :columns="billSharedColumns"
    :noDataText="noDataText"
    :export-data-options="exportDataOptions"
    :extra-export-params="extraExportParams">
    <template v-slot:group-actions-append>
      <date-time
        class="ml-2"
        :getParams.sync="dateParam"
        @refresh="fetchData"
        :hasDefaultTime="false"
        start="start_day"
        end="end_day"
        :canSelectTodayAfter="true"
        paramTimeFormatter="YYYYMMDD" />
      <a-select class="ml-3" :style="{width:billingModeWidth}" :default-value="billSharedType" @change="change">
        <a-select-option v-for="item in billSharedOpts" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
      </a-select>
    </template>
  </page-list>
</template>

<script>
import currencyRequest from '@Bill/mixins/currencyRequest'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'

export default {
  name: 'BillAssociateList',
  components: {
  },
  mixins: [WindowsMixin, currencyRequest, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'shared_bills',
        apiVersion: 'v1',
        getParams: this.getParam,
      }),
      envParams: {},
      amount: 0,
      noDataText: this.$t('bill.text_85'),
      billSharedType: 'month',
      billResourceBuyTime: '',
      billSharedOpts: [
        {
          label: this.$t('bill.bill_shared_by_day'),
          value: 'day',
        },
        {
          label: this.$t('bill.bill_shared_by_month'),
          value: 'month',
        },
      ],
      dateParam: {},
      exportDataOptions: {
        items: [
          { key: 'month', label: this.$t('bill.bill_shared_time') },
          { key: 'usage_start_time', label: this.$t('bill.text_40') },
          { key: 'usage_end_time', label: this.$t('bill.text_41') },
          { key: 'resource_name', label: this.$t('bill.text_72') },
          { key: 'resource_id', label: this.$t('bill.text_120') },
          { key: 'account', label: this.$t('bill.text_60') },
          { key: 'brand', label: this.$t('bill.text_81') },
          { key: 'region', label: this.$t('bill.text_83') },
          { key: 'project', label: this.$t('dictionary.project') },
          { key: 'usage', label: this.$t('bill.text_131') },
          { key: 'usage_unit', label: this.$t('bill.text_281') },
          { key: 'resource_type', label: this.$t('bill.text_73') },
          { key: 'usage_type', label: this.$t('bill.usage_type') },
          { key: 'converted_amount', label: this.$t('bill.converted_amount') },
          { key: 'charge_type', label: this.$t('bill.text_84') },
          { key: 'amount', label: this.$t('bill.text_125') },
        ],
      },
      extraExportParams: {
        time_zone: 'UTC+' + (0 - new Date().getTimezoneOffset() / 60),
      },
    }
  },
  computed: {
    billSharedColumns () {
      const columns = this.columns
      return [
        {
          title: this.$t('bill.bill_shared_time'),
          field: this.billSharedType,
          sortable: true,
          formatter: ({ row }) => {
            return this.dateFormatter(row[this.billSharedType], this.billSharedType)
          },
        },
        {
          field: 'usage_start_time',
          title: this.$t('bill.text_136'),
          minWidth: 100,
          formatter: ({ row }) => `${this.$moment(row.usage_start_time).format(this.$t('bill.text_137'))} - ${this.$moment(row.usage_end_time).format(this.$t('bill.text_137'))}`,
        },
        ...columns,
      ]
    },
    billingModeWidth () {
      if (this.$store.getters.setting.language === 'zh-CN') {
        return '120px'
      }
      return '190px'
    },
  },
  watch: {
    billSharedType (val) {
      this.fetchData()
      this.exportDataOptions.items[0].key = val
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    getParam () {
      return {
        ...this.dateParam,
        detail: true,
        admin: this.$store.getters.isAdminMode,
        is_prepaid_amortizing: true,
        data_type: this.billSharedType,
        order_by: this.billSharedType,
        order: 'asc',
        ...this.getParams,
      }
    },
    fetchData () {
      this.list.getParams = { ...this.getParam(), ...this.currencyParams }
      this.list.fetchData()
    },
    change (value) {
      this.billSharedType = value
    },
    fetchDataCallback () {
      const { data: dataWrap } = this.list
      for (const key in dataWrap) {
        const { data } = dataWrap[key]
        if (data.usage_start_time) {
          this.billResourceBuyTime = `${this.dateFormatter(data.usage_start_time, 'YYYY-MM-DD')} - ${this.dateFormatter(data.usage_end_time, 'YYYY-MM-DD')}`
          return
        }
      }
    },
    dateFormatter (time, type) {
      if (type === 'month') {
        return `${time.toString().substr(0, 4)}-${time.toString().substr(4, 2)}`
      }
      if (type === 'day') {
        return `${time.toString().substr(0, 4)}-${time.toString().substr(4, 2)}-${time.toString().substr(6, 2)}`
      }
      if (type === 'YYYY-MM-DD') {
        const date = this.$moment(time).format(type)
        return date
      }
      return time
    },
  },
}
</script>
